import React from "react";

export const INGREDIENTS_PLACEHOLDER_AR =
  "رز بسمتي : 2 كوب\nبصل : حبة (مفرومة)\nملح : ملعقة صغيرة";
export const INGREDIENTS_PLACEHOLDER_EN =
  "Basmati rice : 2 cups\nOnion : 1 (chopped)\nSalt : 1 tsp";

// Turns a one-line ingredient list ("- a : 1 - b : 2", "1. a 2. b", "• a • b")
// into one ingredient per line — the website shows each line as a row.
export const splitIngredientLines = (text) =>
  String(text || "")
    .replace(/\t/g, " ")
    .replace(/\s*•\s*/g, "\n")
    .replace(/\s+-\s+/g, "\n- ")
    .replace(/\s+(?=\d+\s*[.)]\s)/g, "\n")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .join("\n");

function IngredientsInput({
  id,
  name,
  label,
  value,
  onChange,
  dir,
  placeholder,
  required,
}) {
  const count = String(value || "")
    .split("\n")
    .filter((line) => line.trim()).length;

  const formatLines = () =>
    onChange({ target: { name, value: splitIngredientLines(value) } });

  return (
    <div className="w-[82%] my-[10px]">
      <div className="flex items-center justify-between">
        <label className="text-[14px] font-[500]" htmlFor={id}>
          {label}
          {required && <span className="text-[red] font-[700]">*</span>}
        </label>
        <button
          type="button"
          onClick={formatLines}
          className="rounded-full text-[12px] font-[400] px-3 py-[2px] text-[#0388CC] bg-[#E9F6FD] hover:bg-[#d3edfb]"
        >
          Put each ingredient on its own line
        </button>
      </div>
      <textarea
        id={id}
        name={name}
        dir={dir}
        rows={8}
        required={required}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full mt-1 min-h-[170px] resize-y rounded border-[#c4c8cf] p-2 text-[14px] font-[400] leading-6 placeholder:text-[12px] placeholder:font-[400]"
      />
      <p className="text-[12px] font-[400] text-[#707070]">
        One ingredient per line, e.g. "Item : quantity". {count} line
        {count === 1 ? "" : "s"}.
      </p>
    </div>
  );
}

export default IngredientsInput;
